export const IconWrongPenal = () => {
  return (
    <svg
      className="w-full h-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,1.1L12.6,1.1c6.4,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5
        l0,0C6.3,24.1,1.1,19,1.1,12.6l0,0C1.1,6.3,6.3,1.1,12.6,1.1z"
          fill="#FFEDED"
        />
        <path
          d="M12.6,1.8L12.6,1.8
        c6,0,10.8,4.8,10.8,10.8l0,0c0,6-4.8,10.8-10.8,10.8l0,0c-6,0-10.8-4.8-10.8-10.8l0,0C1.8,6.7,6.7,1.8,12.6,1.8z"
          fill="none"
          stroke="#FFEDED"
          strokeWidth="1.4133"
        />
      </g>
      <g>
        <g clipPath="url(#SVGID_00000119078670038973036220000004203454666849979019_)">
          <path
            d="M13.1,7.1h-11v11h11V7.1z"
            fill="#FFFFFF"
            fillOpacity="1.000000e-02"
          />
          <path
            d="M7.6,17.2
          c2.5,0,4.6-2.1,4.6-4.6c0-2.5-2.1-4.6-4.6-4.6C5.1,8,3,10.1,3,12.6C3,15.1,5.1,17.2,7.6,17.2z"
            fill="none"
            stroke="#D84638"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8088"
          />
          <path
            d="M9,8.6l-1.4,1v1
          L9.4,12l1-0.4L11,10"
            fill="none"
            stroke="#D84638"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8088"
          />
          <path
            d="M6.3,8.6l1.4,1v1
          L5.9,12l-1-0.4L4.3,10"
            fill="none"
            stroke="#D84638"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8088"
          />
          <path
            d="M3.5,12.2l1.4-0.6
          l1,0.4l0.6,2.2L5.9,15H4.1"
            fill="none"
            stroke="#D84638"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8088"
          />
          <path
            d="M5.9,16.4V15
          l0.6-0.8h2.4L9.4,15v1.4"
            fill="none"
            stroke="#D84638"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8088"
          />
          <path
            d="M11.2,15H9.4
          l-0.6-0.8L9.4,12l1-0.4l1.6,0.8"
            fill="none"
            stroke="#D84638"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.8088"
          />
        </g>
      </g>
      <path
        clipRule="evenodd"
        d="M21.1,9.6c0.2,0.2,0.2,0.5,0,0.7l-5.8,5.8c-0.2,0.2-0.5,0.2-0.7,0
      c-0.2-0.2-0.2-0.5,0-0.7l5.8-5.8C20.6,9.5,20.9,9.5,21.1,9.6z"
        fill="#D84638"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.7,9.6c0.2-0.2,0.5-0.2,0.7,0l5.8,5.8c0.2,0.2,0.2,0.5,0,0.7
      c-0.2,0.2-0.5,0.2-0.7,0l-5.8-5.8C14.5,10.1,14.5,9.8,14.7,9.6z"
        fill="#D84638"
        fillRule="evenodd"
      />
    </svg>
  );
};
